import axios from 'axios'
import * as R from 'ramda'

let REFRESH_TOKEN: string | null = null

export const PJ_PANEL_URL = process.env.PJ_PANEL_ENDPOINT
export const LIMIT = 20

if (window.localStorage) {
  REFRESH_TOKEN = window.localStorage.getItem('REFRESH_TOKEN')
}

const createRefreshToken = async () => {
  const response = await axios.post(`${PJ_PANEL_URL}/public/hrpc`, {
    method: 'refreshToken',
    params: { token: REFRESH_TOKEN }
  })
  const responseData = response.data

  if (responseData.status === 'success') {
    setAuthorizationToken(responseData.data.IdToken)
  }
}

export const clearAuthorizationToken = () => {
  if (window.localStorage) {
    window.localStorage.removeItem('ID_TOKEN')
  }
}

export const setRefreshToken = (refreshToken: string) => {
  if (window.localStorage) {
    window.localStorage.setItem('REFRESH_TOKEN', refreshToken)
  }
  REFRESH_TOKEN = refreshToken
}

export const setAuthorizationToken = (idToken: string) => {
  if (window.localStorage) {
    window.localStorage.setItem('ID_TOKEN', idToken)
  }
}

export const clearRefreshToken = () => {
  if (window.localStorage) {
    window.localStorage.removeItem('REFRESH_TOKEN')
  }
  REFRESH_TOKEN = null
}

const generateRequestHeaders = () => ({
  Authorization: window.localStorage.getItem('ID_TOKEN'),
  'Content-Type': 'application/json'
})

export type AuthRequestParams<TParams> = {
  method: string,
  url: string,
  data?: TParams
}
export async function authRequest<TData, TParams> ({ method, url, data }: AuthRequestParams<TParams>): Promise<TData> {
  const axiosParams = R.reject(R.isNil, { method, url, data })
  let response: any

  try {
    response = await axios({ ...axiosParams, headers: generateRequestHeaders() })
  } catch (err) {
    if (err.response) {
      if (err.response.status === 401 && axios.defaults.headers.common.Authorization) {
        await createRefreshToken()
        response = await axios({ ...axiosParams, headers: generateRequestHeaders() })
      } else {
        throw err.response.data
      }
    } else {
      await createRefreshToken()
      response = await axios({ ...axiosParams, headers: generateRequestHeaders() })
    }
  }

  const responseData = response.data

  if (responseData.status !== 'success') {
    throw new Error(responseData.message)
  }

  return responseData.data
}

export type SignInParams = {
  username: string,
  password: string
}
export const signIn = async (params: SignInParams) => {
  const response = await axios.post(`${PJ_PANEL_URL}/public/hrpc`, {
    method: 'signIn',
    params
  })
  const responseData = response.data

  if (responseData.status !== 'success') {
    throw responseData
  }

  return responseData.data
}

export async function publicRequest<TParams, TData> ({ method, url, data }: AuthRequestParams<TParams>): Promise<TData> {
  const axiosParams = R.reject(R.isNil, { method, url, data })
  let response: any

  try {
    response = await axios({ ...axiosParams, headers: { 'Content-Type': 'application/json' } })
  } catch (err) {
    if (err.response) {
      if (err.response.status === 401) {
        response = await axios({ ...axiosParams, headers: { 'Content-Type': 'application/json' } })
      } else {
        throw err.response.data
      }
    } else {
      response = await axios({ ...axiosParams, headers: { 'Content-Type': 'application/json' } })
    }
  }

  const responseData = response.data

  if (responseData.status !== 'success') {
    throw new Error(responseData.message)
  }

  return responseData.data
}
